import { APPLICATION_FORM_PARTS } from "@/rbac/links.js";
import { SORT_APPLICATION_FORM_PART } from "@/rbac/permissions.js";

function props(route) {
  let orderByDefault = route.query.order_by_order || "asc";

  if (
    route.query.order_by_id ||
    route.query.order_by_name ||
    route.query.order_by_category_name
  ) {
    orderByDefault = null;
  }

  return {
    page: parseInt(route.query.page) || 1,
    limit: parseInt(route.query.limit) || 20,

    id: parseInt(route.query.id) || null,
    order_by_id: route.query.order_by_id || null,

    name: route.query.name || null,
    order_by_name: route.query.order_by_name || null,

    order: parseInt(route.query.order) || null,
    order_by_order: orderByDefault,

    category_id: parseInt(route.query.category_id) || null,
    order_by_category_name: route.query.order_by_category_name || null,
  };
}

const applicationFormPartRoutes = [
  {
    path: "/application-form-parts",
    component: () =>
      import(
        /* webpackChunkName: "system-layout" */ "@/views/system/Layout.vue"
      ),
    children: [
      {
        path: "",
        name: "ApplicationFormPartIndex",
        meta: {
          title: "Application Form Parts",
          permission: APPLICATION_FORM_PARTS,
        },
        props: (route) => props(route),
        component: () =>
          import(
            /* webpackChunkName: "application-form-part-index" */ "@/views/system/application-form-part/Index.vue"
          ),
      },
      {
        path: "sort",
        name: "ApplicationFormPartSort",
        meta: {
          title: "Sort Application Form Parts",
          permission: SORT_APPLICATION_FORM_PART,
        },
        component: () =>
          import(
            /* webpackChunkName: "application-form-part-sort" */ "@/views/system/application-form-part/Sort.vue"
          ),
      },
    ],
  },
];

export default applicationFormPartRoutes;
